/**
 * Track frequently visited organizations in localStorage.
 */

const KEY = 'managition:recent-orgs'
const MAX = 6

export interface RecentOrg {
  slug: string
  name: string
  lastVisited: number
  count: number
}

export function getRecentOrgs(): RecentOrg[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const list: RecentOrg[] = JSON.parse(raw)
    return list
      .sort((a, b) => b.count - a.count || b.lastVisited - a.lastVisited)
      .slice(0, MAX)
  } catch {
    return []
  }
}

export function recordOrgVisit(slug: string, name: string): void {
  try {
    const raw = localStorage.getItem(KEY)
    const list: RecentOrg[] = raw ? JSON.parse(raw) : []
    const existing = list.find((o) => o.slug === slug)
    if (existing) {
      existing.count += 1
      existing.lastVisited = Date.now()
      existing.name = name
    } else {
      list.push({ slug, name, count: 1, lastVisited: Date.now() })
    }
    localStorage.setItem(KEY, JSON.stringify(list))
  } catch {
    /* ignore */
  }
}

export function removeRecentOrg(slug: string): void {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return
    const list: RecentOrg[] = JSON.parse(raw)
    localStorage.setItem(KEY, JSON.stringify(list.filter((o) => o.slug !== slug)))
  } catch {
    /* ignore */
  }
}
